export enum KanbanSwimlanes {
    DELAYED = 'delayed',
    NOT_REPORTING = 'notReporting',
    NOT_DELAYED = 'notDelayed',
}
